import { EcommerceAPI } from "../Client";

export const uploadWhatsappMediaApi = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return EcommerceAPI.post("/whatsapp/media/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateWhatsappMessageQueryStatusApi = async (payload) =>
  EcommerceAPI.put("/whatsapp/message/query/status", null, {
    params: { id: payload?.id },
  });

export const enableWhatsappMessageAiResponseApi = async (payload) =>
  EcommerceAPI.put("/whatsapp/message/enable/ai/response", null, {
    params: { id: payload?.id },
  });

export const postWhatsappProductFlowApi = async (payload) =>
  EcommerceAPI.post("/whatsapp/flows/product", payload);

// Pass tenant and the literal hub.mode, hub.challenge, hub.verify_token keys.
export const verifyWhatsappWebhookApi = async (payload) =>
  EcommerceAPI.get(`/webhook/whatsapp/${encodeURIComponent(payload.tenant)}`, {
    params: {
      "hub.mode": payload["hub.mode"],
      "hub.challenge": payload["hub.challenge"],
      "hub.verify_token": payload["hub.verify_token"],
    },
  });

// Keep the tenant path parameter separate from the webhook JSON body.
export const postWhatsappWebhookApi = async (tenant, payload) =>
  EcommerceAPI.post(`/webhook/whatsapp/${encodeURIComponent(tenant)}`, payload);

export const sendWhatsappMessageApi = async (payload) =>
  EcommerceAPI.post("/send/whatsapp/message", null, {
    params: {
      message: payload?.message,
      webhookMessageId: payload?.webhookMessageId,
    },
  });

export const getWhatsappMessageQueriesApi = async (payload) =>
  EcommerceAPI.get("/whatsapp/message/query", {
    params: {
      page: payload?.page,
      size: payload?.size,
      sortBy: payload?.sortBy,
      sortDir: payload?.sortDir,
      ...(payload?.contactNumber ? { contactNumber: payload.contactNumber } : {}),
      ...(payload?.startDate ? { startDate: payload.startDate } : {}),
      ...(payload?.endDate ? { endDate: payload.endDate } : {}),
    },
  });

export const postWhatsappMessageQueryApi = async (payload) =>
  EcommerceAPI.post("/whatsapp/message/query", null, {
    params: {
      phoneNumber: payload?.phoneNumber,
      createdAt: payload?.createdAt,
    },
  });
